import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import CustomDatePickerV2 from 'views/pages/manage/common/commonComponents/CustomDatePicker-V2';
import { customStyle, inputAmountStyle, labelSyle, numberDecimalLimitRegex, paymentModeMapping, 
    // validatePaymentMode 
} from '../../components/constant';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import { useGetCollectPaymentContext } from '../../../context';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { ReactComponent as Scanner } from "assets/img/svg/scanner.svg"
import moment from 'moment';
import { getDOIdDropdown } from '../../dropdowns';
import { loanValidation } from '../../validations/paymentModeValidation';
import Error from '../../errorHandlimg/Error';
import { getConditionalCOllectSaveButton } from '../../components/common';

const Loan = ({ heading ,isEditForm,isReceiptEdit=false, isView=false,contextValue,rowId,handleClose}) => {

    const {
        setPaymentModeForm,
        paymentModeFormHandler,
        studentBasicDetails,
        currentPaymentMode,
        paymentModeForm,
        selectedChargesAmount,
        bankMasterId,
        setBalanceAmount,
        setBalanceMode,
        setloader,
        setCollectPayment,
        collectPayment,
        balanceAmount,
        setModifyPaymentModeData,
        validatePaymentMode,
        disableAmountField
    } = contextValue;

    const [doIdDropdown, setDoIdDropdown] = useState([{}])
    const [errorMgs, setErrorMgs] = useState('')

    useEffect(() => {
        const getDropdown = async () => {
            setloader(true)
            const dropdown = await getDOIdDropdown(studentBasicDetails?.applicationId);
            const vandorDropdown= dropdown?dropdown.filter(item => item?.vendorName == paymentModeMapping[currentPaymentMode]):[]
            setDoIdDropdown(vandorDropdown);
            setloader(false)
            
        }
        !isView && getDropdown();
    }, [heading])

    const validatePayment = async () => {
        const error =  loanValidation(paymentModeForm, collectPayment, currentPaymentMode, balanceAmount)
        setErrorMgs(error)
        if(!error)
            {
               const isOk= await validatePaymentMode(studentBasicDetails,currentPaymentMode,paymentModeForm,selectedChargesAmount,bankMasterId,'',setBalanceAmount,setBalanceMode,setloader,setCollectPayment,balanceAmount,collectPayment)
               if(isOk){
                isReceiptEdit===true && setModifyPaymentModeData((prev) => ({ ...prev, [rowId]: paymentModeForm }))
                isReceiptEdit && handleClose(true)
               }
    
            }   
    }
    const disabled = !(paymentModeForm?.referenceNumber && paymentModeForm?.paidAmount)
    return (
        <>
            {!isView &&!isReceiptEdit && <div className=" d-flex justify-content-between align-items-center mt-2">
                <span className="large-bold color-dark">{heading}</span>
            </div>
            }
            <Row>
                <Col md="4">
                    <div>
                        <AAutoComplete
                            label="DO ID*"
                            labelStyle={labelSyle}
                            placeHolder="Select"
                            currentValue={paymentModeForm?.referenceNumber}
                            handleChange={(value) => {
                                setPaymentModeForm({ ...paymentModeForm, referenceNumber: value, paidAmount: value?.loanAmount })
                            }}
                            items={doIdDropdown}
                            isMulti={false}
                            isShowCount={false}
                            style={{ control: { height: "47px", width: '265px', borderRadius: "5px" } }}
                            isDisabled={isView}
                        />
                    </div>
                </Col>
                <Col md="4">
                    <div>
                        <AInput
                            label="Loan amount disbursed*"
                            labelStyle={labelSyle}
                            value={paymentModeForm?.paidAmount}
                            handler={(value) => {
                                if (
                                    !value || parseFloat(value) > 0
                                ) {
                                    paymentModeFormHandler('paidAmount',value)
                                }

                            }}
                            customIcon={
                                <div className='large-semi-bold'>&#8377;</div>
                            }
                            customIconStyle={customStyle}
                            placeholder="Enter"
                            style={inputAmountStyle}
                            disabled={isView || isReceiptEdit===true || disableAmountField}
                            regex={numberDecimalLimitRegex(10, 2)}
                        />
                    </div>
                </Col>
                <Col md="4">
                    <div style={{ width: '265px' }}>
                        <CustomDatePickerV2
                            label="Disbursement Date"
                            labelStyle={labelSyle}
                            style={{ input: { minHeight: "47px" } }}
                            placeHolder="Select date"
                            value={paymentModeForm?.paymentModeDate}
                            handler={(index, date) => { paymentModeFormHandler("paymentModeDate", date) }}
                            isStartDate={true}
                            //minDate={moment(new Date(), "DD-MM-YYYY").subtract(1, "months")}
                            maxDate={new moment(new Date())}
                            disabled={isView}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <div>
                        <AInput
                            label="UTR ID"
                            labelStyle={labelSyle}
                            value={paymentModeForm?.voucherUTRKey}
                            handler={(value) => { paymentModeFormHandler("voucherUTRKey", value) }}
                            placeholder="Enter"
                            style={{ height: "47px", width: '265px', borderRadius: "5px" }}
                            disabled={isView}
                        />
                    </div>
                </Col>
            </Row>
            {getConditionalCOllectSaveButton(disabled,
                paymentModeForm,
                validatePayment,
                isReceiptEdit,
                isEditForm,
                isView,
                setModifyPaymentModeData,
                rowId,
                handleClose)}
            <Error errorMgs={errorMgs} />
        </>
    )
}
export default Loan;